import * as THREE from 'three'
import { createLine, createMesh } from '../js/map'
import { disposeO3D, disposeO3D_child } from "../js/threejsHelper"
import { renderMap_all, setMapVisible, clearMapGroup, setRoadMarkLocalLaneList } from '../js/allmap_topic'

/**
 * 存放topic 地图的label
 */
let mapLabel_map = new Map();
let index = 10;
let localMapLaneGroup = null;

const disposeObject3D = (object) => {
  if (!object) return
  object.traverse((node) => {
    if (node.geometry) node.geometry.dispose()
    if (node.material) {
      if (Array.isArray(node.material)) {
        node.material.forEach((m) => m?.dispose && m.dispose())
      } else if (node.material.dispose) {
        node.material.dispose()
      }
    }
  })
}

const clearLocalMapLane = () => {
  if (!localMapLaneGroup) return
  while (localMapLaneGroup.children.length > 0) {
    const line = localMapLaneGroup.children.pop()
    disposeObject3D(line)
  }
}

const renderLocalMapLane = (laneList = [], scene) => {
  if (!laneList || !scene) return
  if (!localMapLaneGroup) {
    localMapLaneGroup = new THREE.Group()
    localMapLaneGroup.name = 'local_map_lane_group'
    scene.add(localMapLaneGroup)
  } else if (localMapLaneGroup.parent !== scene) {
    scene.add(localMapLaneGroup)
  }
  clearLocalMapLane()
  load_map_line_all_lane(laneList, 'lane', localMapLaneGroup)
}

export const load_topic_localmap = (mapData, scene, elementSetting_in) => {
  if (mapData?.boundaryList?.length > 0 || mapData?.stopLineList?.length > 0 || mapData?.crossWalkList?.length > 0|| mapData?.speedBumpList?.length>0 || mapData?.roadMarkList?.length || mapData?.parkingList?.length > 0 || mapData?.laneList?.length > 0 || mapData?.localNaviLineList?.length > 0 || mapData?.entryLineList?.length > 0) {
    clearMapGroup()
    index = 5;
    const laneList = mapData?.laneList || []
    setRoadMarkLocalLaneList(laneList)

    const mapDataWithoutLane = laneList.length > 0
      ? { ...mapData, laneList: [] }
      : mapData
    renderMap_all(mapDataWithoutLane, scene, mapLabel_map, true, elementSetting_in)
    renderLocalMapLane(laneList, scene)
  } else {
    setRoadMarkLocalLaneList(null)
    index--
    if (index < 0) {
      clearMapGroup()
      clearLocalMapLane()
    }
  }
}

export const clear_topic_localmap = () => {
  clearLocalMapLane()
}
// /**
//  * 当配置项改变时，检测topic地图数据是否需要变更显示隐藏
//  * @param {*} menuList 
//  */
export const visible_topic_localmap = (menuList) => {
}

const load_map_line_all = (lineData, lineType, scene) => {
  if (!lineData) return
  Promise.resolve().then(() => {
    lineData.forEach((el) => {
      const line = createLine({
        name: lineType,
        type: el.type,
        element: el
      })
      if (line) {
        scene.add(line)
      }
    })
  })
}

const load_map_line_all_lane = (lineData, lineType, scene) => {
  if (!lineData) return
  Promise.resolve().then(() => {
    lineData.forEach((el) => {
      const line = createLine({
        name: lineType,
        type: el.type,
        element: el
      })
      if (line) {
        if (line.material) line.material.dispose()
        line.material = new THREE.LineDashedMaterial({
          color: 0xffffff,
          transparent: true,
          opacity: 0.8,
          dashSize: 0.8,
          gapSize: 0.6
        })
        line.computeLineDistances()

        // 最后一点加一个箭头 用红色，表示方向
        if (el.pointList && el.pointList.length >= 2) {
          const last = el.pointList[el.pointList.length - 1]
          const prev = el.pointList[el.pointList.length - 2]
          const direction = new THREE.Vector3(last.x - prev.x, last.y - prev.y, 0)
          if (direction.lengthSq() > 1e-8) {
            direction.normalize()
            const origin = new THREE.Vector3(last.x, last.y, 0.08)
            const arrow = new THREE.ArrowHelper(direction, origin, 1.8, 0xff0000, 0.65, 0.35)
            arrow.renderOrder = 300
            arrow.line.material.depthTest = false
            arrow.cone.material.depthTest = false
            line.add(arrow)
          }
        }
        scene.add(line)
      }
    })
  })
}

const load_map_mesh_all = (data, type, scene) => {
  Promise.resolve().then(() => {
    const setting = getMapSettingByType(type)
    data?.forEach((el) => {
      if (!setting.mapObject.has(el.id)) {
        const mesh = createMesh({
          name: type,
          element: el
        })
        if (mesh) {
          if (!setting.mapObject.has(el.id)) {
            mesh.positionEX = el.pointList[0]
            mesh.renderOrder = -20
            setting.group.add(mesh)
            setting.mapObject.set(el.id, mesh)
          } else {
            mesh.geometry.dispose()
          }
        }
      }
    })
  })
}






